module.exports = __webpack_public_path__ + "static/media/kinedu_educators_color.34b9ec60.png";